import React, { Component } from "react";
import { Modal, message, Spin, Button, } from "antd";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import InvInfor from "./components/InvInfor.js";
import InvServiceContent from "./components/InvServiceContent.js";
import ClientParams from "./components/ClientParams.js";
import Fetch from "../../../common/Fetch.js";
import ExportUtil from "../../../common/ExportUtil.js";
import HistoryRecord from "./HistoryRecord.js";

class DockingData extends Component {
    state = {
        params: {},
        type: "view",
        visible: false,
        loading: false,
        fileList: [],
        byStageList: [],
        evaluateServeConfigList: [], //项目服务内容
        researchProductTypeList: [],
        historyRecordList: [],  //历史记录
        recordData: {},
    };

    componentDidMount(){
        const urlParams = this.getUrlParams();
        const { evaluateRecordId } = urlParams;
        if (evaluateRecordId) {
            this.loadData(evaluateRecordId);
            this.loadRecordData(evaluateRecordId);
        }
        const { historyData = {} } = this.props;
        const { evaluateRecordId: historyEvaluateRecordId, evaluateRecordBasicVersionId } = historyData;
        if (historyEvaluateRecordId && evaluateRecordBasicVersionId) {
            this.loadData(historyEvaluateRecordId, evaluateRecordBasicVersionId);
            this.loadRecordData(historyEvaluateRecordId);
        }
    }

    getUrlParams = () => {
        let href = window.location.href;
        let obj = {};
        if (href.includes("?")) {
            let query = href.substring(href.indexOf("?") + 1);
            let item = query.split("&");
            for (let i = 0; i < item.length; i++) {
                let arr = item[i].split("=");
                obj[arr[0]] = arr[1];
            }
        };
        return obj
    }

    loadRecordData = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecords,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.setState({
                    recordData: datas[0] || {},
                });
            }
        };
        $.sendRequest(options);
    }

    loadData = (evaluateRecordId, evaluateRecordBasicVersionId) => {
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateRecordBasicData,
            data: {
                evaluateRecordId,
                evaluateRecordBasicVersionId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                        evaluateServeConfigList, //项目服务内容
                    }
                } = res;
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                            sponsorCompanyName: evaluateRecordView.sponsorName,
                        },
                        loading: false,
                        evaluateServeConfigList,
                    },() => 
                    {
                        this.handelfirstOption()
                        this.loadHistoryRecordData();
                    }
                );
            },
        }
        $.sendRequest(options);
    }

    handelfirstOption = () => {
        const { researchProductTypeList, params } = this.state;
        params[`researchProductTypeIdValue`] = params.researchProductTypePCId ? params.researchProductTypePCId.split(',') : [];
        params[`researchProductTypeIdValue`] = params[`researchProductTypeIdValue`].map(el => el = Number(el));
        if(!!params[`researchProductTypeIdValue`].length) {
            const researchProductTypeItem = researchProductTypeList.find(el => params[`researchProductTypeIdValue`][0] == el.evaluateConfigureId )
            const code = researchProductTypeItem ? researchProductTypeItem.code : undefined;
            if (code) {
                Fetch.post(API_URL.common.queryInvestigationByStageByMedicine, { 
                    investigationMedicineType: code
                })
                    .then(res => {
                        this.setState({ byStageList: res.data });
                    })
                    .catch(error => console.log(error));
            } else {
                this.setState({ byStageList: [] });
            }
        }
    }

    queryEnclosureFileList = () => {
        const { params: { evaluateRecordId } } = this.state
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEnclosureFileList,
            data: { 
                relateId: evaluateRecordId,
                uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE'
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.datas || [];
                fileList.forEach(item => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = item.fileMateId;
                });
                this.setState({
                    fileList,
                });
            }
        };
        $.sendRequest(options);
    }

    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object') {
                result[key] = value;
            }
        }
        return result;
    }

    handelRequired = () => {
        const { params } = this.state;
        const InvInforConfig =  this.InvInforRef.handleDomRender();
        const ClientParamsConfig =  this.ClientParamsRef.handleDomRender();
        try {
            InvInforConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber') {
                        if( params[name] === undefined || params === null || params === '' ) {
                            throw label
                        }
                    } else if(type === 'SearchRetrieve') {
                        if( !params[`${name}Id`] || !params[`${name}Name`]) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
            ClientParamsConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber') {
                        if( params[name] === undefined || params === null || params === '' ) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        return true
    }

    // submit = () => {
    //     const { params, type } = this.state;
    //     if(!this.handelRequired()) {
    //         return
    //     }
    //     this.setState({ loading: true });
    //     const options = {
    //         method: "POST",
    //         url: API_URL.evaluate.saveEvaluateServeCustomer,
    //         data: {
    //             ...this.splitParams(params),
    //         },
    //         dataType: "json",
    //         doneResult: (res) => {
    //             message.success(res.success);
    //             this.setState(
    //                 {
    //                     loading: false,
    //                 },
    //                 () => {
    //                     this.hide();
    //                     this.props.loadData();
    //                 }
    //             );
    //         },
    //         errorResult: () => {
    //             this.setState({ loading: false });
    //         },
    //     };
    //     $.sendRequest(options);
    // };

    handleParamsChange = (params) => {
        this.setState({ params:{
            ...params,
        } });
    };

    handleEvaluateServeChange = (value) => {
        this.setState({ 
            evaluateServeConfigList: JSON.parse(value)
        });
        this.saveEvaluateServeValue(JSON.parse(value))
    }

    saveEvaluateServeValue = (config = []) => {
        const { params } = this.state;
        const evaluateRecordServeIds = [];
        config.map(item => {
            const { children = [] } = item;
            children.map( child => {
                const { children = [] } = child;
                children.map(option => {
                    const { selected, evaluateServeId } = option;
                    if(selected) evaluateRecordServeIds.push(evaluateServeId);
                }) 
            })
        })
        this.setState({
            params: {
                ...params,
                evaluateRecordServeIds: evaluateRecordServeIds.join(',')
            }
        })
    }

    dataExport = () => {
        const { params } = this.state;
        const { evaluateRecordId, evaluateSerialNumber } = params;
        const url = API_URL.evaluate.exportEvaluateRecordVisit;
        ExportUtil.export({ evaluateRecordId, evaluateSerialNumber }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    loadHistoryRecordData = () => {
        const { params: { evaluateCode } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryBasicVersionList,
            data: { evaluateCode, limit: 9999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    historyRecordList: res.datas,
                })
            }
        };
        $.sendRequest(options);
    }

    getContent = () => {
        const { 
            params, 
            type,
            fileList,
            byStageList,
            evaluateServeConfigList,
            researchProductTypeList,
            historyRecordList = [],
        } = this.state;
        const { showHistory = true } = this.props;
        const DomArr = [
            {
                title: showHistory ? <span>
                    项目基本信息
                    <Button 
                        key="history" 
                        type="primary" 
                        style={{marginLeft: 10}} 
                        disabled={historyRecordList.length == 0} 
                        onClick={() => this.HistoryRecordRef.show(params, historyRecordList)}
                        >
                        历史记录
                    </Button>
                    </span> : '项目基本信息',
                Dom: <InvInfor 
                        key='InvInfor'
                        type={type}
                        params={params}
                        byStageList={byStageList}
                        researchProductTypeList={researchProductTypeList}
                        ref={el => this.InvInforRef = el}
                        handleParamsChange={this.handleParamsChange}
                    />
            },
            {
                title: '项目服务内容',
                Dom: <InvServiceContent 
                        key='InvServiceContent'
                        type={type}
                        params={params} 
                        Config={evaluateServeConfigList}
                        handleParamsChange={this.handleParamsChange}
                        handleEvaluateServeChange={this.handleEvaluateServeChange}
                    />
            },
            {
                title: '客户项目参数',
                Dom: <ClientParams 
                        key='ClientParams'
                        type={type}
                        isDocking={true}
                        params={params}
                        fileList={fileList}
                        ref={el => this.ClientParamsRef = el}
                        handleParamsChange={this.handleParamsChange}
                        record={this.state.recordData}
                    />
            },
        ];
        return <div
                    className="modal-content"
                    style={{ padding: "0 20px" }}
                >
                    {
                        DomArr.map((el, index) => {
                            const { show = true } = el;
                            return show && <div>
                                        <div style={{ 
                                            fontSize: 14,
                                            fontWeight: '700',
                                            margin: '10px 0'
                                        }}>
                                            {`${index + 1 }.`}{el.title}
                                        </div>
                                        {el.Dom}
                                    </div>
                        })
                    }
                </div>
    }

    render() {
        const { 
            params: { evaluateCode },
        } = this.state;
        return <div style={{ width: '100%', height: '100%', background: '#ffffff' }}>
                <div style={{ padding: 40 }}>
                <div style={{ overflow: 'hidden' }}>
                    <div style={{ float: 'left', marginBottom: '10px'}}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                        >&#xe65b;</i>
                        {`临床评估单号：${evaluateCode}`}
                    </div>
                </div>
                    {this.getContent()}
                    <HistoryRecord ref={el => this.HistoryRecordRef = el}/>
                </div>
            </div>
    }
}

export default DockingData;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/DockingData.js